export default __webpack_public_path__ + "static/media/subhero2.de7a5775.jpeg";